import React from 'react';
import classNames from 'classnames';

import { useTabsContext } from '../tabsContext';

import styles from './tabStyles.scss';

const TabContent: React.FC<{
  children: JSX.Element[];
  unmountOnChange?: boolean;
}> = ({ children, unmountOnChange }): React.ReactElement => {
  const { activeTab } = useTabsContext();

  return (
    <>
      {children && unmountOnChange ? (
        <div className={classNames(styles.content, styles.contentVisible)}>
          {children[activeTab]}
        </div>
      ) : (
        children.map(
          (child, idx): React.ReactElement => (
            <div
              key={idx}
              className={classNames(styles.content, {
                [styles.contentVisible]: activeTab === idx
              })}
            >
              {child}
            </div>
          )
        )
      )}
    </>
  );
};

export default TabContent;
